import React, { useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { removeItem, selectCartItems } from "../redux/slices/cartSlice";
import { selectProducts } from "../redux/slices/productsSlice";
import { saveOrderToLocalStorage } from "../utils/orderStorage";
import classes from "./CartDrawer.module.css";

export default function CartDrawer() {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();

  const cartItems = useSelector(selectCartItems);
  const products = useSelector(selectProducts);

  const enrichedItems = useMemo(
    () =>
      cartItems.map((item) => {
        const product = products.find((p) => p.id === item.productId);
        return { ...product, ...item };
      }),
    [cartItems, products],
  );

  const totalQuantity = useMemo(
    // () => cartItems.reduce((sum, item) => sum + (item.quantity || 0), 0)//

    () => cartItems.length,
    [cartItems],
  );

  return (
    <>
      <button
        type="button"
        className={classes.cartButton}
        onClick={() => setOpen(true)}
        aria-label="סל קניות"
      >
        <svg
          viewBox="0 0 24 24"
          fill="currentColor"
          className={classes.cartIcon}
          aria-hidden="true"
        >
          <path d="M2.25 2.25a.75.75 0 0 0 0 1.5h1.386c.17 0 .318.114.362.278l2.558 9.592a3.752 3.752 0 0 0-2.806 3.63c0 .414.336.75.75.75h15.75a.75.75 0 0 0 0-1.5H5.378A2.25 2.25 0 0 1 7.5 15h11.218a.75.75 0 0 0 .674-.421 60.358 60.358 0 0 0 2.96-7.228.75.75 0 0 0-.525-.965A60.864 60.864 0 0 0 5.68 4.509l-.232-.867A1.875 1.875 0 0 0 3.636 2.25H2.25ZM3.75 20.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM16.5 20.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z" />
        </svg>
        {totalQuantity > 0 && (
          <span className={classes.badge}>{totalQuantity}</span>
        )}
      </button>

      <div
        className={`${classes.drawerOverlay} ${open ? classes.open : ""}`}
        onClick={() => setOpen(false)}
      />

      <aside className={`${classes.drawer} ${open ? classes.open : ""}`}>
        <header className={classes.drawerHeader}>
          <h2 className={classes.drawerTitle}>עגלת קניות</h2>
          <button
            type="button"
            className={classes.closeButton}
            onClick={() => setOpen(false)}
            aria-label="סגור עגלה"
          >
            <svg
              viewBox="0 0 24 24"
              fill="currentColor"
              className={classes.closeIcon}
              aria-hidden="true"
            >
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
            </svg>
          </button>
        </header>

        <div className={classes.cartContent}>
          {enrichedItems.length === 0 ? (
            <div className={classes.cartEmpty}>
              העגלה שלך ריקה. הוסף מוצרים מדפי הקטגוריות.
            </div>
          ) : (
            enrichedItems.map((item) => (
              <div key={item.productId} className={classes.cartItem}>
                <div className={classes.cartItemInfo}>
                  <p className={classes.cartItemName}>{item.name || "פריט"}</p>
                  <p className={classes.cartItemMeta}>
                    כמות: {item.quantity || 0}
                  </p>
                  {item.comment && (
                    <p className={classes.cartItemComment}>
                      הערה למוצר: {item.comment}
                    </p>
                  )}

                  {item.userCommentAnswer && (
                    <p className={classes.cartItemResponse}>
                      תשובתך: {item.userCommentAnswer}
                    </p>
                  )}
                </div>

                <div className={classes.cartItemActions}>
                  {/* <input
                    type="number"
                    min={0}
                    value={item.quantity}
                    readOnly
                    aria-label="כמות"
                  /> */}
                  <button
                    type="button"
                    onClick={() => {
                      dispatch(removeItem(item.productId));
                      saveOrderToLocalStorage("RemoveItem", cartItems, item);
                    }}
                  >
                    הסר
                  </button>
                </div>
              </div>
            ))
          )}
        </div>

        <div className={classes.drawerFooter}>
          <Link to="/orders/form" onClick={() => setOpen(false)}>
            <button type="button" disabled={enrichedItems.length === 0}>
              המשך לטופס הזמנה
            </button>
          </Link>
        </div>
      </aside>
    </>
  );
}
